import type { CSSProperties, ReactNode } from 'react';
import { QUIZ_CARD_MIN_H } from './quiz-card';

/**
 * The card a finished quiz lands in.
 *
 * `resultLine` owns the sentence INSIDE the result screen; this owns the
 * surface under it, which every caller was writing out by hand — the same
 * seven classes and the same custom property in three files, which is three
 * chances for the result card to stop being one card.
 *
 * The colour is the products colour: the result is where the page turns from
 * playing to buying.
 */
export function QuizFinishedCard({ children }: { children: ReactNode }) {
  return (
    <div
      style={{ '--sf-q1': 'var(--sf-prod)' } as CSSProperties}
      className={`sf-quiz-card flex ${QUIZ_CARD_MIN_H} flex-col gap-3 rounded-[var(--sf-radius)] p-5 text-white`}
    >
      {children}
    </div>
  );
}
